module.exports = __webpack_public_path__ + "img/logo-white-vertical.aad3585c.svg";